import { Controller } from "@hotwired/stimulus";
import "./component.scss"

// The row's interactive behaviour (mobile asks for the detail as a Turbo
// Stream) lives in the shared `mobile-stream-request` controller, wired in the
// template. This shell stays for the SCSS import.
export default class extends Controller {
  connect() {}
}
